@if (useRijksVersion()) {
  <ng-container [ngTemplateOutlet]="rijksTemplate" />
} @else {
  <ng-container [ngTemplateOutlet]="tnghTemplate" />
}

<ng-template #rijksTemplate>
  <div class="login-wrapper">
    <header class="login-wrapper__header">
      <dsrks-hero
        [variant]="logoVariant"
        [logoUrl]="logoUrl"
        [logoAltText]="logoAltText"
        logoWidth="258"
        logoHeight="125"
      />
      <dsrks-topbar variant="rijks">
        <ng-container ngProjectAs="left">
          <p class="topbar-title">Wachtwoord vergeten</p>
        </ng-container>
      </dsrks-topbar>
    </header>
    <div class="login-wrapper__content">
      <div class="login-wrapper__content__bg-image"></div>
      <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="login-wrapper__form">
        <div class="login-wrapper__back-link">
          <a [routerLink]="['/', RoutingNames.authentication, RoutingNames.loginOtp]"
            ><ds-icon name="arrow-left" />Terug naar inloggen
          </a>
        </div>
        <fieldset>
          <h2>Wachtwoord vergeten</h2>

          <ds-form-grid>
            <div class="form-row">
              <ds-input
                class="span-12"
                formControlName="emailAddress"
                i18n-label="@@emailaddressField"
                label="E-mailadres"
                type="text"
              />
            </div>
          </ds-form-grid>
        </fieldset>
        <div class="login-wrapper__cta">
          <ds-button i18n="Set password button@@ResetPasswordPageButton" type="submit"
            >Nieuw wachtwoord aanvragen</ds-button
          >
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #tnghTemplate>
  <div class="login-screen">
    <a routerLink="/">
      <tngh-logo />
    </a>

    <tngh-form-card>
      <tngh-button
        class="login-back-button"
        variant="back"
        label="Back"
        iconPosition="start"
        (click)="onClickBackButton()"
        iconName="chevron-left"
      />
      <form [formGroup]="formGroup" class="form-card-form-wrapper">
        <fieldset>
          <legend class="form-card-form-wrapper__legend" i18n>Request password reset</legend>
          <tngh-form-grid>
            <tngh-text-input
              class="span-6"
              formControlName="emailAddress"
              helpText="Enter the email address you use to login"
              i18n-helpText="Enter your email address that you use to login@@ResetPasswordEmailaddressFieldHelptext"
              label="Email address"
              i18n-label="@@emailaddressField"
            />
          </tngh-form-grid>
        </fieldset>
        <div class="login-screen__cta">
          <tngh-button
            [debounceTime]="500"
            (clickEvent)="onSubmit()"
            type="submit"
            i18n-label="@@resetRequestSubmitButton"
            [fullwidth]="true"
            label="Submit"
          />
        </div>
      </form>
    </tngh-form-card>
  </div>
</ng-template>
